import { defineBoot } from '#q-app/wrappers';

import type { AxiosInstance } from 'axios';
import axios from 'axios';
import { useOidcStore } from 'src/stores/oidc';
import { API_URL } from 'src/utils/config';

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $axios: AxiosInstance;
  }
}

export const apiUrl = API_URL;

// Be careful when using SSR for cross-request state pollution
// due to creating a Singleton instance here;
// If any client changes this (global) instance, it might be a
// good idea to move this instance creation inside of the
// "export default () => {}" function below (which runs individually
// for each client)
const apiClient = axios.create({ baseURL: API_URL });

export default defineBoot(({ app }) => {
  const oidcStore = useOidcStore();
  // for use inside Vue files (Options API) through this.$axios and this.$api

  app.config.globalProperties.$axios = axios;
  // ^ ^ ^ this will allow you to use this.$axios (for Vue Options API form)
  //       so you won't necessarily have to import axios in each vue file
  apiClient.interceptors.request.use(function (config) {
    config.headers.Authorization = `Bearer ${oidcStore.access_token}`;
    return config;
  });

  apiClient.interceptors.response.use(
    function (response) {
      // handle Expired token, which should not happen if browser in normal state
      if (
        response.status === 401 &&
        response.data.message === 'Expired JWT Token'
      ) {
        oidcStore.signinRedirect();
      }
      return response;
    },
    function (error) {
      return Promise.reject(error);
    },
  );

  app.config.globalProperties.$api = apiClient;

  // ^ ^ ^ this will allow you to use this.$api (for Vue Options API form)
  //       so you can easily perform requests against your app's API
});

export { axios, apiClient };
